import { render } from "./VideoPrincipal.vue?vue&type=template&id=f9a9dfd0&scoped=true"
import script from "./VideoPrincipal.vue?vue&type=script&lang=js"
export * from "./VideoPrincipal.vue?vue&type=script&lang=js"

import "./VideoPrincipal.vue?vue&type=style&index=0&id=f9a9dfd0&lang=scss&scoped=true"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a9dfd0"]])

export default __exports__